















import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { BlackListDto } from "@/store/blacklists/blacklist.interface";

@Component
export default class AppBlackListItem extends Vue {
  @Prop() item: BlackListDto;
  @Prop() index: number;
  updatedItem: BlackListDto;

  @Watch("item")
  onItemChanged(val: BlackListDto, oldVal: BlackListDto) {
    this.item = val;
  }
}
